import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import selectors from './partnerManagerEmployeeManagementSelectors';
import KeyfobsAndEmployeesList from './KeyfobsAndEmployeesList/KeyfobsAndEmployeesList';
import Spinner from '../../../components/Spinner/Spinner';
import CardInfo from '../../../components/CardInfo/CardInfo';
import UploadMemberRecipientsForm from './UploadMemberRecipients/UploadMemberRecipientsForm/UploadMemberRecipientsForm';

function PartnerManagerEmployeeManagementTab({ partnerId, isLoading, launchDate }) {
    const employeesListRef = useRef();
    return <CardInfo shadow={false} halfSpace>
        {isLoading ? <Spinner /> : null}
        <UploadMemberRecipientsForm partnerId={partnerId} launchDate={launchDate} />
        <KeyfobsAndEmployeesList partnerId={partnerId} ref={employeesListRef} />
    </CardInfo>;
}

PartnerManagerEmployeeManagementTab.propTypes = {
    partnerId: PropTypes.number.isRequired,
    isLoading: PropTypes.bool.isRequired,
    launchDate: PropTypes.instanceOf(Date).isRequired,
};
const connectStateToProps = connect(selectors);
export default connectStateToProps(PartnerManagerEmployeeManagementTab);
